import { Component, inject, ViewChild } from '@angular/core';
import { ModalPartCategoryComponent } from 'src/app/components/inventory-modals/modal-part-category.component';
import { Category } from 'src/app/models/category';
import { Part } from 'src/app/models/part';
import { InventoryService } from 'src/app/services/inventory.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-parts-categories',
  template: `
    <div class="d-flex flex-column mb-4 mt-4">
      <div class="flex-column">
        <h1>Partes</h1>
      </div>
      <div class="flex-column">
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
    <div class="d-flex">
    <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
        <ul #sidebar class="list-unstyled">            
          <li><button class="btn btn-zazz-default active rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/parts" >Partes</button></li>
          <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerlLink="/inventory">Inventario</button></li>
          <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/purchase-orders" >Compras</button></li>
          <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/sales">Ventas</button></li>
        </ul>
        <h4 class="mt-1 ms-3 mb-3" style="font-size: 1.2em">Partes</h4>
        <ul #subsidebar class="list-unstyled">
          <li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" routerLink="/inventory/parts/categories" >Categorías</button></li>
          <!-- li><button class="btn btn-zazz-default rounded-4 shadow-sm w-100 px-4 mb-3" (click)="openModalPartCategory()" >Parámetros</button></!-->
        </ul>
      </div>
      <div #pages class="flex-fill">
      <div class="d-flex mt-0">
        <div class="flex-fill">
          <div class="ms-2">
            <h3>Categorías</h3>
          </div>
          <div class="d-flex">
            <div class="flex-fill">
              <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openModalPartCategory()">
                <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
                Agregar
              </button>
            </div>
          </div>
          <div class="list-group rounded-5 shadow mt-4" >
            <div class="list-group-item px-4 py-3 border-0">
              <div class="d-flex flex-fill mt-2">
                <div class="btn-group text-center w-100" role="group" aria-label="Filtro recibos">
                  
                </div>
              </div>
            </div>
            <div class="list-group-item w-100" >
              <table class="table table-sm" style="overflow-x: scroll;">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz text-light py-2 rounded-start-3">Nombre <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-start bg-zazz text-light py-2">Descripción</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Subcategorias</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Estructural</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Partes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-parts-category
                    [category]="category"
                    [profile]="profile" 
                    [permissions]="permissions"
                    
                    *ngFor="let category of categories | paginate: { itemsPerPage: query.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal-part-category></app-modal-part-category>
  `,
  styles: [
  ]
})
export class PartsCategoriesComponent {
  categories: Category[] = [];
  profile: any = JSON.parse(sessionStorage.getItem(STORAGE_KEYS.PROFILE) ?? '{}');
  permissions: any = {};

  @ViewChild(ModalPartCategoryComponent, { static: true }) modalPartCategoryComponent !: ModalPartCategoryComponent;

  query: any = {
    details: true,
    location_detail: true,
    per_page: 25,
    page: 0
  };
  meta: any = {};

  p: number = 1;

  constructor(
    private invService: InventoryService,
    public icons: IconsService
  ) {
    this.loadParts();
  }

  loadParts() {
    this.invService.getCategories(this.query).subscribe({
      next: (categories: any) => {
        console.log('categories ', categories);
        this.categories = categories.results;
      },
      error: (err: any) => {}
    });
  }

  openModalPartCategory(): void {
    console.log('createContract => ', this.modalPartCategoryComponent);
    const modalTemplate: any | undefined = this.modalPartCategoryComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalPartCategory']);
    }
  }

}
